export const consultTypeEnum = {
  RPS: 'search-nfserps',
  BATCH: 'search-batch',
  SITUATION: 'search-situation',
};
